/* eslint-disable no-multi-str */
import { Translations } from "./types";
import { hero, whoIam, home, prices, header, footer, contacts, form, career, projects, chat, blog, testimonials, howItWorks, projectResults, game } from "../data";

// Traduzione italiana completa di tutti i contenuti
export const it: Translations = {
  game: {
    ...game,
    navLabel: "🎮 Gioco",
    title: "Il Mondo di Angelo",
    subtitle: "Esplora il mio portfolio come un gioco!",
    intro: {
      title: "Benvenuto nel Mondo di Angelo! 🎮",
      text: "La tua missione: visita tutti i 6 edifici e raccogli le 8 gemme delle competenze per completare il villaggio. Parla con l'abitante, prova i quiz, pesca al laghetto... e tieni gli occhi aperti: questo villaggio nasconde più di un segreto!",
      controlsTitle: "Comandi",
      controls: [
        "WASD / Frecce — muoviti",
        "Spazio — salta",
        "E / Invio — interagisci",
        "Esc — chiudi i pannelli",
      ],
      start: "Inizia a esplorare",
    },
    hud: {
      skills: "Competenze",
      exit: "Torna al sito classico",
      interact: "Premi E per entrare",
      interactTouch: "Tocca ✋ per entrare",
      zonesVisited: "Edifici",
      quizStars: "Quiz",
      challenge: "⏱ Sfida gemme",
      challengeStop: "⏱ Ferma sfida",
      challengeTime: "Tempo",
      challengeBest: "Record",
      achievements: "🏅 Traguardi",
    },
    touch: {
      jump: "Salta",
      interact: "✋",
    },
    skillCollected: "Competenza raccolta:",
    allSkillsCollected: "🏆 Fantastico! Hai raccolto tutte le mie competenze!",
    prompts: {
      quiz: "Quiz del villaggio — premi E",
      quizTouch: "Quiz del villaggio — tocca ✋",
      quizDone: "Quiz completato ⭐",
      fishing: "Pesca delle koi — premi E",
      fishingTouch: "Pesca delle koi — tocca ✋",
      arcade: "Sala giochi — premi E",
      arcadeTouch: "Sala giochi — tocca ✋",
      secret: "Giardino segreto — premi E",
      secretTouch: "Giardino segreto — tocca ✋",
      drone: "Tour col drone — premi E per decollare",
      droneTouch: "Tour col drone — tocca ✋ per decollare",
      bike: "Bicicletta — premi E per pedalare",
      bikeTouch: "Bicicletta — tocca ✋ per pedalare",
    },
    drone: {
      hint: "🛸 Drone cam",
      controls: "W/A/S/D — vola · Spazio — sali · Shift — scendi",
      controlsTouch: "▲▼◀▶ vola · ⤴ sali · ⤵ scendi",
      land: "E / Esc — atterra",
      landTouch: "🛬 Atterra",
      altitude: "ALT",
      takeoffToast: "🛸 Drone in volo! Goditi il villaggio dall'alto.",
      landedToast: "🛬 Drone in rientro verso la piazzola.",
    },
    bike: {
      controls: "W/A/S/D — pedala",
      controlsTouch: "▲▼◀▶ pedala",
      dismount: "E / Esc — scendi",
      dismountTouch: "🚲 Scendi",
      mountToast: "🚲 In sella! Pedala per il villaggio.",
      dismountToast: "🚲 Bici parcheggiata qui.",
    },
    npc: {
      name: "Angelo",
      welcome: "Ciao! Sono Angelo 👋 Benvenuto nel mio villaggio! Visita gli edifici e raccogli le gemme delle competenze per completarlo.",
      missingBoth: "Ti mancano ancora {zones} edifici da visitare e {gems} gemme da trovare. Prova anche i cartelli quiz vicino alle porte!",
      missingZones: "Tutte le gemme raccolte! 💎 Ora ti aspettano ancora {zones} edifici.",
      missingGems: "Hai visto tutti gli edifici! 🏠 Restano {gems} gemme nascoste per la mappa.",
      done: "Hai completato tutto! Un vero esploratore 🎉 Allora... parliamo del tuo progetto? 😉",
    },
    quest: {
      completedToast: "🎆 Villaggio completato!",
    },
    final: {
      title: "🎆 Villaggio completato!",
      text: "Hai esplorato tutto il mio mondo: edifici, gemme e tutto il resto. È esattamente la curiosità con cui nascono i grandi progetti. Ora tocca a me lavorare per te!",
      secretCode: "Codice segreto: VILLAGE100 — citalo nella nostra call per uno sconto sulla tua prima settimana!",
      cta: "Prenota una call gratuita",
      share: "Condividi su LinkedIn",
      close: "Continua a esplorare",
    },
    quiz: {
      title: "Quiz del Villaggio",
      correct: "Corretto! ⭐ Hai guadagnato una stella quiz!",
      wrong: "Non proprio... riprova!",
      alreadyDone: "Hai già risposto a questo quiz! ⭐",
      close: "Chiudi",
      questions: {
        whoiam: {
          question: "Dove vivo?",
          options: ["A Milano", "A Sondrio, nel cuore delle Alpi", "A Torino"],
          answer: 1,
        },
        career: {
          question: "Dove ho conseguito le mie lauree in ingegneria?",
          options: ["Politecnico di Milano", "Università di Bologna", "Sapienza di Roma"],
          answer: 0,
        },
        projects: {
          question: "Cosa gestisce la piattaforma che ho costruito per Smanno?",
          options: ["Una flotta di robot e le loro missioni", "Un negozio di vestiti online", "Un social network per chef"],
          answer: 0,
        },
        prices: {
          question: "Cosa succede se la prima settimana di lavoro non ti convince?",
          options: ["Niente, paghi comunque", "Ricevi un rimborso del 100%", "Paghi metà prezzo"],
          answer: 1,
        },
        contact: {
          question: "In quanto tempo posso essere operativo sul tuo progetto?",
          options: ["In meno di 24 ore", "In circa un mese", "Dopo 2 settimane di onboarding"],
          answer: 0,
        },
        testimonials: {
          question: "Per quale startup musicale ho contribuito a lanciare un MVP?",
          options: ["GUT Music", "Spotify", "SoundCloud"],
          answer: 0,
        },
      },
    },
    fishing: {
      title: "Pesca delle Koi 🎣",
      instructions: "Ferma l'indicatore dentro la zona verde per pescare una carpa!",
      action: "Ferma!",
      retry: "Riprova",
      caught: "Hai pescato una koi! 🐟",
      missed: "Oh no, è scivolata via...",
      factLabel: "La koi ti sussurra un segreto su Angelo:",
      facts: [
        "Vivo a Sondrio, nel cuore delle Alpi 🏔️",
        "Adoro i giochi da tavolo e i videogiochi 🎲",
        "Ho sia la patente A che la B 🏍️",
        "Amo viaggiare e leggere libri 📚",
        "Questo gioco è fatto solo con CSS 3D — nessun game engine! 🛠️",
        "Le mie migliori qualità? Determinazione e sincerità 💪",
      ],
    },
    arcade: {
      hubTitle: "Sala Giochi 🕹️",
      hubIntro: "Scegli un cabinato e prova a battere il tuo record!",
      backToMenu: "← Torna al menu",
      start: "Inizia",
      score: "Punteggio",
      lives: "Vite",
      best: "Record",
      playAgain: "Rigioca",
      close: "Chiudi",
      runner: {
        title: "Robot Runner 🤖",
        instructions: "Muovi il robot con A/D o le frecce: raccogli le provette 🧪 ed evita i bug 🐛. Tre vite!",
        gameOver: "Game over!",
      },
      archery: {
        title: "Tiro con l'Arco al Torii 🏹",
        instructions: "Clicca i bersagli prima che svaniscano. Sbagliane 3 e il gioco finisce!",
        gameOver: "Game over!",
      },
      koiRhythm: {
        title: "Ritmo delle Koi 🎵",
        instructions: "Premi Spazio (o tocca Cattura!) nell'istante in cui la koi salta nel cerchio. Tre errori terminano la partita!",
        combo: "Combo",
        catch: "Cattura!",
        gameOver: "Game over!",
      },
      lanternRunner: {
        title: "Corsa delle Lanterne 🏮",
        instructions: "Premi Spazio (o tocca Salta!) per superare gli ostacoli. La velocità aumenta più resisti!",
        jump: "Salta!",
        gameOver: "Game over!",
      },
      wishCatcher: {
        title: "Acchiappa Desideri 🌠",
        instructions: "Clicca quante più stelle cadenti puoi prima che scada il tempo!",
        timeLeft: "Tempo",
        gameOver: "Tempo scaduto!",
      },
    },
    challenge: {
      toastDone: "Sfida completata in {time}s!",
      newRecord: "🏆 Nuovo record: {time}s!",
    },
    secret: {
      unlockedToast: "✨ Hai scoperto il giardino segreto!",
      title: "Giardino Zen Segreto ♨️",
      paragraphs: [
        "Benvenuto nel mio angolo nascosto del villaggio! Solo i veri esploratori arrivano fin qui.",
        "Quando non programmo: cammino e mi arrampico per le Alpi, gioco a giochi da tavolo e videogiochi, viaggio e leggo tutto quello che mi capita a tiro.",
        "Curiosità: tutto questo villaggio — il 3D, la fisica, le koi — è costruito a mano con React e trasformazioni CSS, senza game engine. Se metto questa cura in un easter egg, immagina nel tuo progetto. 😉",
      ],
    },
    wish: "Hai espresso un desiderio! ✨",
    achievements: {
      title: "Traguardi",
      share: "Condividi su LinkedIn",
      close: "Chiudi",
      unlockedToast: "🏅 Traguardo sbloccato: {name}",
      items: {
        explorer: { name: "Esploratore", description: "Visita tutti i 6 edifici" },
        collector: { name: "Collezionista di Gemme", description: "Raccogli tutte le 8 gemme" },
        quizmaster: { name: "Maestro dei Quiz", description: "Rispondi a tutti i 6 quiz del villaggio" },
        fisherman: { name: "Sussurratore di Koi", description: "Pesca 3 carpe al laghetto" },
        speedrunner: { name: "Speedrunner", description: "Completa la sfida gemme in meno di 40s" },
        arcade: { name: "Eroe Arcade", description: "Fai 20+ punti a Robot Runner" },
        secret: { name: "Scopritore di Segreti", description: "Trova il giardino zen segreto" },
        wisher: { name: "Osservatore di Stelle", description: "Clicca una stella cadente ed esprimi un desiderio" },
        pilot: { name: "Pilota di Droni", description: "Vola col drone sopra il villaggio" },
        cyclist: { name: "Ciclista del Villaggio", description: "Fai un giro in bicicletta per il villaggio" },
      },
    },
    zones: {
      whoiam: { name: "La Mia Casa", emoji: "🏠", hint: "Chi sono" },
      career: { name: "Torre della Carriera", emoji: "🏛️", hint: "Carriera e formazione" },
      projects: { name: "Sala Giochi dei Progetti", emoji: "🕹️", hint: "I miei progetti" },
      prices: { name: "Bottega dei Piani", emoji: "🏪", hint: "I miei piani" },
      contact: { name: "Ufficio Postale dei Contatti", emoji: "📮", hint: "Contattami" },
      testimonials: { name: "Piazza dei Trofei", emoji: "🏆", hint: "Cosa dicono i clienti" },
    },
    panels: {
      close: "Chiudi",
      visitWebsite: "Apri link",
      bookACall: "Prenota una call gratuita",
    },
  },
  hero: {
    ...hero,
    hello: "Ciao 👋, sono",
    name: "Angelo Falci",
    title: "Software Engineer, Esperto di AI e Full Stack Developer",
    contacts: "Contatti",
    mainSkills: "Ecco le mie principali competenze/conoscenze:",
    paragraphs: [
      "Ciao, sono Angelo e vivo nel cuore delle Alpi, a Sondrio (a nord di Milano), in Italia. Sono appassionato di programmazione e sono sempre alla ricerca di nuove sfide per imparare e migliorare le mie competenze. Sono una persona molto attiva e motivata. Le mie qualità principali sono la determinazione e la sincerità. Dall'altra parte i miei difetti sono... aspetta, forse è meglio non dire i difetti in un curriculum.",
      "Sono appassionato di AI e utilizzo/testo diversi strumenti per velocizzare e migliorare il mio lavoro.",
      "Nel mio tempo libero mi piace sperimentare e provare nuove tecnologie sviluppando applicazioni web full stack. Qui sotto puoi vedere maggiori dettagli sulla mia esperienza lavorativa e sui miei progetti!",
      "I miei altri hobby sono: viaggiare, leggere libri, giochi da tavolo, videogiochi e fare sport",
      "Ho la patente B e A"
    ],
  },
  blog: {
    ...blog,
    subtitle: "Pensieri, tutorial e appunti dal mio percorso come software engineer.",
    readMore: "Leggi di più",
    backToBlog: "Torna al blog",
    minRead: "min di lettura",
    publishedOn: "Pubblicato il",
    filterByTag: "Filtra per tag",
    allPosts: "Tutti gli articoli",
    noPosts: "Nessun articolo in Italiano ancora. Torna presto!",
    loadMore: "Carica altri",
  },
  chat: {
    ...chat,
    title: "Chatta con l'AI (beta)",
    welcome: "Ciao! Sono l'assistente AI di Angelo. Chiedimi qualsiasi cosa su di lui o prova la modalità Gioco per un'esperienza più immersiva!",
    placeholder: "Scrivi un messaggio...",
    send: "Invia",
    openChat: "Apri chat",
    tooltipHint: "Chiedimi qualcosa! 💬",
    closeChat: "Chiudi chat",
  },
  testimonials: {
    ...testimonials,
    title: "Cosa Dicono i Clienti",
    trustedBy: "Aziende e startup con cui ho lavorato",
    metrics: [
      { value: "7+", label: "Anni di esperienza" },
      { value: "20+", label: "Progetti consegnati" },
      { value: "24h", label: "Operativo da subito" },
      { value: "100%", label: "Soddisfatto o rimborsato" },
    ],
    items: [
    {
      quote: "Angelo è un professionista molto pratico ed efficace, capace di portare avanti progetti complessi in autonomia, restando aperto al confronto e al miglioramento.\nAbbiamo collaborato in università su un progetto di robotica (HW/SW) concluso con successo e oggi lui sviluppa software avanzato per la startup di robotica dove lavoro.\nHa una forte mentalità da problem solver con un approccio concreto e diretto: lavora solo su ciò che è chiaro e davvero necessario, evitando sprechi di tempo.\nConsigliato senza dubbi: se dice che qualcosa non si può fare, è perché ci ha già provato seriamente. 💪",
      author: "Emanuele Schiavon — Smanno and Other",
      role: "CTO",
    },
    {
      quote: "Lavoro e continuo a lavorare con Angelo da più di un anno: con obiettivi chiari mai un problema, soluzioni veloci, efficaci e funzionanti entro poche ore o al massimo giorni. Una certezza! 😜",
      author: "Davide Pedrazzini - Smanno",
      role: "Chief Dream Officer",
    },
    {
      quote: "Abbiamo collaborato con Angelo durante lo sviluppo e il rilascio dell’MVP della piattaforma GUT Music, dove il suo contributo è stato determinante per raggiungere il livello qualitativo desiderato.\
      Si è distinto per disponibilità e reattività, rispondendo rapidamente alle richieste e proponendo spesso soluzioni già pronte, qualità fondamentali in un contesto dinamico.\
      La collaborazione è stata semplice ed efficace: continueremo a lavorare insieme e lo consigliamo senza riserve per affidabilità, competenza e capacità di incidere anche in situazioni complesse.",
      author: "Luca Finardi — GUT Music",
      role: "Founder & CEO",
    },
  ],
  }, cookieConsent: {
    title: "Questo sito usa i cookie",
    description: "Questo sito utilizza cookie di analisi di terze parti (Google Analytics) per raccogliere informazioni statistiche sull’utilizzo del sito. Puoi accettare o rifiutare l’uso di questi cookie.",
    accept: "Accetta",
    decline: "Rifiuta",
  },
  whoIam: {
    ...whoIam,
    paragraphs: [
      "Sono un software engineer appassionato, focalizzato sul problem solving e sulla creazione di soluzioni pragmatiche per reali esigenze dei clienti.",
      "Ho lavorato sia con grandi aziende che con startup in fase iniziale, collaborando in team ma anche consegnando progetti end-to-end in autonomia.",
      "Sono abituato a lavorare direttamente con i clienti, comprendere le reali esigenze di business e trasformarle in software funzionante.",
      "Mi muovo con sicurezza su tutto lo stack e imparo rapidamente nuove tecnologie, sfruttando anche moderni strumenti di AI per lavorare in modo più efficiente.",
      "Do grande valore a una comunicazione chiara e diretta con i miei clienti. Voglio che capiscano perfettamente come intendo risolvere il loro problema e sono sempre onesto se c’è qualcosa che in quel momento non so e ho bisogno di approfondire.",
    ],
  },
  home: {
    ...home,
    title: ["La tua idea startup, migliorata e trasformata in un", "MVP funzionante", "in poche settimane"],
    subhead: "Sviluppatore full-stack senior operativo in meno di 24 ore. Modello ad abbonamento settimanale: soddisfatto o rimborsato.",
    subtitle: "Sei nel posto giusto se:",
    paragraphs: [
      "Hai un'idea ma ti serve un MVP funzionante in settimane, non in mesi.",
      "Vuoi integrare l'AI nel tuo prodotto per fare davvero la differenza.",
      "Ti serve uno sviluppatore senior operativo subito, senza mesi di onboarding.",
    ],
    footerText: "Non perdere tempo, contattami e costruiamo insieme qualcosa di grande!",
    caption: "Non conto le ore di lavoro, conto gli obiettivi raggiunti",
    ctas: {
      ...home.ctas,
      lookPlans: "Guarda i miei piani",
      speakGoals: "Prenota una consulenza gratuita",
    },
  },
  howItWorks: {
    ...howItWorks,
    title: "Come funziono",
    subtitle: "Tre step, zero rischio per te.",
    steps: [
      {
        title: "Prenoti una call gratuita",
        text: "Capiamo insieme il tuo obiettivo e se sono la persona giusta — posso iniziare anche il giorno dopo.",
      },
      {
        title: "Lavoro a sprint settimanali",
        text: "Sprint di una settimana con aggiornamenti e demo regolari: vedi i progressi reali e sai il costo in anticipo.",
      },
      {
        title: "Soddisfatto o rimborsato",
        text: "Se la prima settimana non ti convince, te la rimborso. Continui solo se sei soddisfatto.",
      },
    ],
    cta: "Prenota una call gratuita",
  },
  prices: {
    ...prices,
    title: "I Miei Piani",
    subtitle: "Scegli il piano che meglio si adatta alle tue esigenze.",
    footerText: "Hai richieste particolari? Creiamo un piano su misura!",
    ctaBookPlan: "Prenota",
    ctaMoreDetails: "Dettagli",
    plans: prices.plans.map((p) => {
      if (p.type === "WEEKLY") {
        return {
          ...p,
          title: "Da € 800",
          subtitle: "Sprint Veloce",
          description: "La tua idea realizzata in tempi record. Deliverable: una funzionalità o miglioramento concreto live entro una settimana.",
          included: [
            "Lavoro su 1 tuo progetto per 1 settimana",
            "Se non sei soddisfatto, ti rimborso il 100%",
            "Aggiornamenti giornalieri sullo stato avanzamento",
            "Puoi contattarmi per supporto in qualsiasi momento"
          ],
          footer: "Cosa posso fare in una settimana? Vedi i dettagli",
          longtext: [
            {
              type: "subtitle",
              value: "Come funziona?",
            },
            {
              type: "text",
              value: "Funziona come un abbonamento, per 1 settimana sono a tua disposizione per lavorare su uno dei tuoi progetti senza perdere tempo in contratti o burocrazia.\
              \nChiamami e posso iniziare già dal giorno successivo.\
              \nQuesto piano è ideale per piccoli task o per testarmi prima di iniziare una collaborazione più lunga."
            },
            {
              type: "subtitle",
              value: "Vantaggi",
            },
            {
              type: "text",
              value: "- Puoi avere uno sviluppatore disponibile in meno di 24 ore\n- Non perdo tempo a contare le ore, lavoro per risultati aggiornandoti periodicamente\n- Puoi pagarmi solo per il tempo in cui hai bisogno, senza contratti a lungo termine\n- Sai esattamente quanto pagherai fin da subito\n- Se non sei soddisfatto, ti rimborso l'intero costo della settimana"
            },
            {
              type: "subtitle",
              value: "Tempistiche",
            },
            {
              type: "text",
              value: "Cosa riesco a fare in una settimana?\
              \nDipende dalla complessità del progetto o dalle funzionalità, ma in generale potrei:\
              \n- Sviluppare diverse funzionalità di media complessità (es. integrazione pagamento, sviluppo di una pagina con già un concept chiaro)\
              \n- Integrazione di un chatbot sul proprio sito\
              \n- Integrazione di analitiche avanzate su un sito esistente\
              \n- Internalizzazione di un sito esistente in più lingue\
              \n- Creazione e pubblicazione di una semplice MVP\
              \n- Sviluppare e pubblicare una landing page"
            }
          ],
        };
      }
      if (p.type === "MONTHLY") {
        return {
          ...p,
          title: "Da € 2600",
          subtitle: "Progetto Completo",
          description: "Il tuo prodotto sviluppato da zero alla fine. Deliverable: modulo, set di funzionalità o MVP funzionante dopo un mese di lavoro intenso.",
          included: [
            "Lavoro su 1 tuo progetto per 1 mese",
            "Se non sei soddisfatto, ti rimborso il 100%",
            "Demo settimanali per mostrarti i progressi reali",
            "Puoi contattarmi per supporto in qualsiasi momento"
          ],
          footer: "Cosa posso fare in 1 mese? Vedi i dettagli",
          longtext: [
            {
              type: "subtitle",
              value: "Come funziona?",
            },
            {
              type: "text",
              value: "Funziona come un abbonamento, per 1 mese sono a tua disposizione per lavorare su uno dei tuoi progetti senza perdere tempo in contratti o burocrazia.\nChiamami e posso iniziare già dal giorno successivo.\nQuesto piano è ideale se hai bisogno di uno sviluppatore che lavori con te o con il tuo team per uno o più mesi senza contratti a lungo termine."
            },
            {
              type: "subtitle",
              value: "Vantaggi",
            },
            {
              type: "text",
              value: "- Puoi avere uno sviluppatore disponibile in meno di 24 ore\n- Non perdo tempo a contare le ore, lavoro per risultati aggiornandoti periodicamente\n- Puoi pagarmi solo per il tempo in cui hai bisogno, senza contratti a lungo termine\n- Sai esattamente quanto pagherai fin da subito\n- Se iniziamo e non sei soddisfatto, puoi interrompere il noleggio quando vuoi e ti rimborserò il costo della prima settimana"
            },
            {
              type: "subtitle",
              value: "Tempistiche",
            },
            {
              type: "text",
              value: "Cosa riesco a fare in un mese?\
              \nDipende dalla complessità del progetto o dalle funzionalità, ma in generale potrei:\
              \n- Sviluppare molte funzionalità anche complesse (es. integrazione pagamento, sviluppo di una pagina con già un concept chiaro)\
              \n- Integrazione di servizi AI avanzati su un sito esistente o sviluppo di un'applicazione che li utilizza\
              \n- Integrazione di un chatbot avanzato con sistema di RAG su un sito esistente\
              \n- Creazione e pubblicazione di una MVP completa"
            }
          ],
        };
      }
      /* HOURLY plan temporarily disabled
      if (p.type === "HOURLY") {
        return {
          ...p,
          description: "Ideale per piccoli task o per avere uno sviluppatore/consulente disponibile per un breve periodo di tempo.",
          included: [
            "1 o più ore dedicate in riunioni 1:1 se per consulenza",
            "Compilerò regolarmente il tuo timesheet se per sviluppo",
            "Puoi contattarmi per supporto in qualsiasi momento",
          ],
          footer: "Se devi rendicontare le ore",
          longtext: [
            {
              type: "text",
              value: "In generale preferisco non lavorare contando le ore: per esperienza è una perdita di tempo per entrambe le parti e rende più difficile sapere in anticipo quanto spenderai, ma in alcuni casi specifici può essere utile."
            },
            {
              type: "subtitle",
              value: "Quando usare questo piano",
            },
            {
              type: "text",
              value: "- Se hai bisogno di uno sviluppatore per task molto piccoli che possono essere completati in poche ore\n- Se hai bisogno di 1 o più ore di consulenza\n- Se devi conteggiare le ore per processi interni"
            }
          ],
        };
      }
      */
      if (p.type === "CUSTOM") {
        return {
          ...p,
          subtitle: "Partnership Continuativa",
          description: "Un partner tecnico a lungo termine che conosce il tuo codebase e i tuoi obiettivi di business — adattato alle tue esigenze.",
          included: [
            "Piano personalizzato sulle tue specifiche esigenze",
            "Scope flessibile: manutenzione, nuove funzionalità o consulenza",
            "Puoi contattarmi per supporto in qualsiasi momento"
          ],
          footer: "Una soluzione su misura per te",
          longtext: [
            {
              type: "subtitle",
              value: "Come funziona?",
            },
            {
              type: "text",
              value: "Scegli questo piano se non sei sicuro di quanto tempo ti servirà o se hai requisiti specifici.\nContattami, parleremo delle tue esigenze e creerò un piano personalizzato per te.\nIn alcuni casi posso applicare uno sconto o aumentare il prezzo, in base alla situazione."
            },
            {
              type: "subtitle",
              value: "Esempi in cui è utile",
            },
            {
              type: "text",
              value: "- Se hai bisogno di uno sviluppatore per un lungo periodo (più di 3 mesi) posso applicare uno sconto\n- Se hai bisogno di qualcuno che mantenga il tuo progetto con poche ore a settimana/mese posso applicare uno sconto\n- Se hai bisogno di sviluppare la tua soluzione in tempi molto brevi posso aumentare il prezzo per dare priorità al tuo progetto\n- Se sei una startup con poco budget, posso farti uno sconto e ricevere equity nella tua startup"
            }
          ],
        };
      }
      if (p.type === "CONSULTANT") {
        return {
          ...p,
          description: "Consulenza o task breve con priorità.",
          included: [
            "1 ora prioritaria sul tuo progetto",
            "Rimborso 100% se non soddisfatto",
            "Focus su decisioni o problemi urgenti",
          ],
          footer: "Per una consulenza singola",
          longtext: [
            {
              type: "text",
              value:
                "Hai 1 ora del mio tempo con priorità rispetto agli altri clienti. Ideale per urgenze o decisioni rapide.",
            },
          ],
        };
      }
      return p;
    }),
  },
  header: {
    ...header,
    home: "Home",
    prices: "Prezzi",
    whoiam: "Chi sono",
    career: "Carriera",
    aboutMe: "Su di me",
    projects: "Progetti",
    contacts: "Contatti",
    experience: "Esperienza",
    blog: "Blog",
    toggle: "Attiva/Disattiva",
    generatePdf: "Scarica PDF",
    menuOpen: "Apri menu",
    menuClose: "Chiudi menu",
  },
  footer: {
    ...footer,
    center: "Sito realizzato con React",
    center2: "e amore",
  },
  contacts: {
    ...contacts,
    title: "Contattami 😃",
    subtitle:
      "Se non sei libero negli slot disponibili, utilizza gli altri contatti per raggiungermi e ti risponderò il prima possibile!",
    bookACall: "Prenota una call",
  },
  form: {
    ...form,
    useModule: "Contattami utilizzando il modulo qui sotto",
    leaveMessage: "Lascia il tuo messaggio",
    thanks: "Grazie per il tuo messaggio! Ti risponderò il prima possibile!",
    backToTop: "Torna su",
    send: "Invia",
  },
  career: {
    ...career,
    title: "Carriera e studi",
    schools: career.schools.map((school) => {
      if (school.title === "State Examination for Information Engineering") {
        return {
          ...school,
          title: "Esame di Stato per Ingegneria Informatica",
          where: "Politecnico di Milano, Italia",
          description: "Superato l’esame di Stato per l’abilitazione all’esercizio della professione di ingegnere.",
          when: "2025",
        };
      }
      if (school.title === "Master’s Degree in Computer Science and Engineering") {
        return {
          ...school,
          title: "Master of Computer Science and Engineering",
          where: "Politecnico di Milano, Italia",
          description: "Scarica qui tutti i dettagli sui corsi che ho seguito:",
          when: "2016 - 2018",
          links: school.links?.map((l) => ({ ...l, title: l.title })),
        };
      }
      if (school.title === "Bachelor’s Degree in Computer Science and Engineering") {
        return {
          ...school,
          title: "Laurea Triennale in Ingegneria Informatica",
          where: "Politecnico di Milano, Italia",
          description: "Scarica qui tutti i dettagli sui corsi che ho seguito:",
          when: "2013 - 2016",
          links: school.links?.map((l) => ({ ...l, title: l.title })),
        };
      }
      if (school.title === "High School Diploma in Computer Science") {
        return {
          ...school,
          title: "Diploma perito informatico",
          where: "Istituto tecnico ITIS Enea Mattei (Sondrio, Italia)",
          when: "2008 - 2013",
        };
      }
      return school;
    }),
    jobs: career.jobs.map((job) => {
      if (job.company === "Freelance") {
        return {
          ...job,
          title: "Software Engineer",
          description:
            "Lavoro come freelance sviluppando applicazioni web fullstack per grandi aziende o startup integrando servizi di IA dove necessario. Oltre allo sviluppo aiuto i clienti a migliorare le idee e scegliere le migliori tecnologie e architetture.",
          whereAndWhen: "Remoto, 04/2025 - Presente",
        };
      }
      if (job.company === "DeltaTre") {
        return {
          ...job,
          title: "Senior Frontend Developer",
          description:
            "Ho lavorato al progetto Diva, un player video custom con molte funzionalità. Le principali tecnologie utilizzate sono React, Vanilla JS, TypeScript, RxJS, Node, Storybook, Webpack e Babel.",
          whereAndWhen: "Da remoto, 09/2022 - 04/2025",
        };
      }
      if (job.company === "TeamSystem") {
        return {
          ...job,
          title: "Senior FullStack Developer",
          description:
            "Ho lavorato principalmente con React e Redux per mantenere e migliorare l’applicazione Digitalbox. Ho inoltre collaborato occasionalmente con sviluppatori backend per aggiornare o correggere bug nelle API scritte in NodeJS o Java (Spring Boot).",
          whereAndWhen: "Da remoto, 10/2021 - 09/2022",
        };
      }
      if (job.company === "Consultant at Stellantis" && job.whereAndWhen.includes("Turin")) {
        return {
          ...job,
          title: "Autonomous Driving Software Engineer",
          description:
            "Come consulente NetcomGroup ero responsabile della manutenzione e dello sviluppo di diversi strumenti utilizzati per validare software di guida autonoma. Inoltre, insieme al mio team, abbiamo studiato e testato nuove metodologie e software per migliorare la toolchain di Stellantis.",
          whereAndWhen: "Torino - Italia, 02/2020 - 10/2021",
        };
      }
      if (job.company === "Consultant at Stellantis" && job.whereAndWhen.includes("Munich")) {
        return {
          ...job,
          title: "Autonomous Driving Software Engineer",
          description:
            "Come consulente NetcomGroup ho studiato come integrare alcuni strumenti nei sistemi Stellantis per creare una toolchain in grado di validare software di guida autonoma.",
          whereAndWhen: "Monaco di Baviera - Germania, 10/2019 - 02/2020",
        };
      }
      if (job.company === "Accenture") {
        return {
          ...job,
          title: "Frontend Developer",
          description:
            "Ho lavorato come frontend developer per progettare e sviluppare siti web performanti e responsive per clienti di grande importanza, utilizzando diverse tecnologie come React, Redux, ES6, HTML, CSS, Docker e altre.",
          whereAndWhen: "Milano - Italia, 11/2018 - 10/2019",
        };
      }
      if (job.company === "JOL Laboratory, TIM") {
        return {
          ...job,
          title: "IoT Developer",
          description:
            "Per la mia tesi ho lavorato con un team su un progetto europeo che aveva come obiettivo principale la creazione di un’applicazione Android utilizzabile per comunicare e raccogliere dati da diversi dispositivi smart (vedi la sezione progetti per maggiori dettagli).",
          whereAndWhen: "Milano - Italia, 05/2018 - 09/2018",
        };
      }
      return job;
    }),
  },
  projectResults: {
    ...projectResults,
    "Smanno": "Piattaforma full-stack per flotte di robot ospedalieri, costruita da zero e installata in sede.",
    "Orbiting Rocks": "Demo generata con AI portata in produzione; cliente confermato dopo la prima settimana.",
    "GUT": "MVP stile Spotify rilasciato: streaming video, pagamenti Stripe e CMS dedicato.",
    "Portfolio Online": "Sito personale realizzato in React/TypeScript e pubblicato su Firebase con integrazione di servizi AI.",
  },
  projects: {
    ...projects,
    title: "Altri progetti",
    mainTitle: "Ultimi Progetti in Evidenza",
    subtitle: "(clicca sul titolo o sul testo della card per più dettagli)",
    footerText: "Per altri progetti guarda il mio GitHub!",
    projects: projects.projects.map((project) => {
      switch (project.title) {
        case "Smanno":
          return {
            ...project,
            description: "Ho progettato e sviluppato una piattaforma fullstack per gestire flotte di robot e missioni complesse, usata in ambito sanitario e ospedaliero.",
            links: project.links?.map((l) => ({ ...l, label: "Smanno - Sito ufficiale" })),
            longtext: [
              {
                type: "title",
                value: "Caso Studio",
              },
              {
                type: "subtitle",
                value: "Contesto",
              },
              {
                type: "text",
                value: "Smanno è una startup composta da 3 persone (me compreso) che sviluppa soluzioni di automazione nei laboratori clinici, utilizzando principalmente robotica collaborativa sia fissa che mobile.\
                \nIl ruolo principale del fondatore di Smanno era lo sviluppo del business e le relazioni con i clienti. L’altra persona, CTO di Smanno, era responsabile dello sviluppo hardware dei robot.\
                \nInfine io ero responsabile dello sviluppo di tutto il software della piattaforma e del suo deployment negli ambienti dei clienti."
              },
              {
                type: "subtitle",
                value: "Sfide Affrontate",
              },
              {
                type: "text",
                value: "Collaborare con una startup in fase iniziale è stata una sfida tanto complessa quanto gratificante.\
                \nAlcune delle problematiche affrontate sono state:\
                \n- Sviluppare una piattaforma software da zero, partendo da un’idea e da requisiti molto generici\
                \n- Realizzare una piattaforma flessibile e scalabile, in grado di gestire diversi tipi di robot e missioni complesse, con un’interfaccia utente intuitiva per il personale ospedaliero non tecnico\
                \n- Lavorare con hardware e robot diversi, con protocolli di comunicazione differenti, e pensare ad integrare tutto in un’unica piattaforma software\
                \n- Gestire il deployment della piattaforma nei diversi ambienti dei clienti"
              },
              {
                type: "subtitle",
                value: "Soluzione Implementata",
              },
              {
                type: "text",
                value: "Ho sviluppato la piattaforma in modo che fosse il più flessibile possibile nei vari step di sviluppo per due ragioni:\
                \n- Applicare rapide modifiche al cambio dei requisiti, cosa molto frequente in una startup in fase iniziale,\
                \n- Gestire diversi tipi di robot e missioni senza modificare la codebase per ogni nuovo tipo di robot o missione. In breve, per farlo ho astratto tutto in 2 entità: Actor (come robot e altre macchine/luoghi che interagiscono con i robot) e Mission (il task che i robot devono eseguire).\
                \nPer permettere di eseguire il codice in qualsiasi sistema operativo ho sfruttato Docker, il che ha semplificato anche l'esecuzione della piattaforma anche agli altri membri del team meno tecnici.\
                \nLa piattaforma è divisa in 2 parti principali: il backend sviluppato in Django e il frontend sviluppato in React, più sotto i dettagli tecnici di ognuno\
                \nIl cliente veniva aggiornato con messaggi ogni volta che avevo pronta una nuova release o guardando la Kanban del progetto su GitHub stesso dove si trovava anche il codice. Quest'ultima veniva aggiornata sia da me che dai membri di Smanno."
              },
              {
                type: "subtitle",
                value: "Vantaggi del Modello ad Abbonamento",
              },
              {
                type: "text",
                value: "Il modello ad abbonamento ha portato diversi:\
                \n- Il cliente ha potuto avere uno sviluppatore operativo in meno di 24 ore, senza perdere tempo in contratti o burocrazia e testando fin da subito la mia capacità di consegnare risultati concreti\
                \n- Il cliente ha avuto costi prevedibili nel corso dei mesi di sviluppo\
                \n- Io ho potuto sviluppare velocemente la piattaforma concentrandomi sui risultati senza perdere tempo a rendicontare le ore"
              },
              {
                type: "title",
                value: "Dettagli tecnici",
              },
              {
                type: "subtitle",
                value: "Backend - Django",
              },
              {
                type: "text",
                value: "Ho sviluppato il backend della piattaforma utilizzando *Django* e *MySQL* come database. Le principali funzionalità implementate sono:\
    \n- *Architettura del database* per la gestione di robot, missioni e utenti\
    \n- *REST API* per il frontend con controlli sui permessi utente\
    \n- *Processi asincroni* per verificare lo stato dei robot connessi alla piattaforma\
    \n- *Integrazione con servizi e librerie di terze parti* per comunicare con diversi robot\
    \n- *Pagina Admin di Django* con funzionalità avanzate di gestione dei dati\
    \n- Creazione di *comandi personalizzati Django* per semplificare installazione e gestione della piattaforma\
    \n- *Documentazione Swagger* per tutte le REST API implementate\
    \n- Documentazione tecnica per installare e gestire la piattaforma\
    \n- *File Docker Compose* per avviare e configurare database, backend e frontend con un solo comando\
    \n- *Servizi Socket* per aggiornamenti in tempo reale nel frontend sullo stato dei robot e delle missioni"
              },
              {
                type: "subtitle",
                value: "Frontend - React",
              },
              {
                type: "text",
                value: "Ho sviluppato il frontend utilizzando *React* con *Bootstrap 5* come libreria UI. Le funzionalità disponibili dipendono dal ruolo e dai permessi assegnati: *admin, editor, executor e viewer*.\
    \nLe principali funzionalità implementate sono:\
    \n- *Design responsive* per mobile e desktop\
    \n- Creazione di *missioni complesse* suddivise in step utilizzando *actor* e *missioni atomiche*\
    \n- Possibilità di *riutilizzare e incapsulare missioni* per ottimizzare i flussi operativi\
    \n- *Monitoraggio in tempo reale* tramite comunicazione socket dello stato delle missioni e degli actor\
    \n- Possibilità di *fermare e riprendere le missioni*\
    \n- *Visualizzazione di statistiche* sull’esecuzione delle missioni e sulle performance dei robot"
              },
              {
                type: "subtitle",
                value: "Deployment",
              },
              {
                type: "text",
                value: "L’applicazione è progettata per essere installata sui *server dei clienti Smanno*, come quelli ospedalieri, ed essere accessibile dai dispositivi collegati alla stessa rete.\
    \nHo creato un *file Docker Compose* per avviare database, backend e frontend in tre container distinti con un solo comando.\
    \nSuccessivamente ho sviluppato uno *script di esportazione delle immagini Docker*, accompagnato da script automatici per l’importazione e l’avvio sui server dei clienti, sia in ambiente *Linux* che *Windows*.\
    \nTutti i file vengono generati in una cartella di output pronta per il deploy.\
    \nQuesto processo potrà essere ulteriormente ottimizzato in base alle esigenze future dei clienti."
              }
            ],
          };
        case "Orbiting Rocks":
          return {
            ...project,
            description: "Partendo da una demo creata con AI ho realizzato e pubblicato un sito completo non limitandomi alla demo ma migliorandola e proponendo nuove funzionalità.",
            longtext: [
              {
                type: "title",
                value: "Caso Studio",
              },
              {
                type: "subtitle",
                value: "Contesto",
              },
              {
                type: "text",
                value: "Orbiting Rocks è un progetto ideato dal cliente con il supporto di strumenti di AI.\
    \nL'obiettivo del tool è trasformare la cybersecurity in uno strumento capace di rendere le startup early-stage più comprensibili, trasparenti e affidabili agli occhi di investitori e partner.",
              },
              {
                type: "subtitle",
                value: "Sfide Affrontate",
              },
              {
                type: "text",
                value: "Il cliente disponeva di una demo realizzata con strumenti di AI, composta da file HTML contenenti JavaScript e CSS non modularizzati.\
    \nLa richiesta principale era:\
    \n- Correggere bug e migliorare la qualità del codice\
    \n- Implementare funzionalità non realizzabili con i soli strumenti di AI\
    \n- Preparare e pubblicare il sito online\
    \nIl tutto rispettando un budget limitato.",
              },
              {
                type: "subtitle",
                value: "Soluzione Implementata",
              },
              {
                type: "text",
                value: "Intervenire direttamente su file contenenti migliaia di righe di codice non strutturato sarebbe stato inefficiente, mentre una riscrittura completa avrebbe comportato costi e tempi eccessivi.\
    \nPer questo motivo ho adottato un approccio ibrido, utilizzando strumenti di AI per convertire la demo in un'applicazione React, successivamente ottimizzata e migliorata manualmente.\
    \nInoltre, ho proposto e implementato nuove funzionalità per rendere il prodotto più completo. Nella versione originale, i dati venivano salvati localmente; ho quindi introdotto un sistema di autenticazione e la persistenza su database, consentendo l'accesso alle informazioni da qualsiasi dispositivo.\
    \nInfine, ho pubblicato l'applicazione online tramite Firebase Hosting, integrandolo con GitHub Actions per realizzare una pipeline di deploy automatizzata, efficiente e gratuita per il cliente nelle fasi iniziali.\
    \nIl cliente è rimasto costantemente aggiornato durante lo sviluppo: a ogni push poteva visualizzare e testare le modifiche in tempo reale su un ambiente di staging Firebase.",
              },
              {
                type: "subtitle",
                value: "Vantaggi del Modello ad Abbonamento",
              },
              {
                type: "text",
                value: "In questo progetto il cliente ha usufruito di due settimane del piano settimanale. Inizialmente titubante, ha deciso di procedere grazie alla garanzia soddisfatti o rimborsati.\
    \nSoddisfatto dei risultati ottenuti nella prima settimana, ha confermato l'intero periodo di collaborazione.\
    \nL'assenza di rendicontazioni orarie gli ha permesso di modificare e integrare i requisiti senza il timore di costi imprevisti.\
    \nParallelamente, l'ho supportato nella prioritizzazione delle richieste, garantendo il massimo valore entro i tempi concordati.",
              },
              {
                type: "title",
                value: "Dettagli tecnici",
              },
              {
                type: "subtitle",
                value: "React e IA",
              },
              {
                type: "text",
                value: "Ho scelto *React* per ricostruire la demo e ottenere un codice più *strutturato*, *leggibile* e *manutenibile*, in linea con gli *standard moderni di sviluppo frontend*.\
  \nHo utilizzato in modo estensivo *agenti AI* per generare il codice a partire dalla demo esistente, perfezionandolo e arricchendolo progressivamente con *nuove funzionalità*.\
  \nHo integrato *Tailwind CSS* per velocizzare lo sviluppo e garantire un design *coerente*, *responsive* e *facilmente scalabile*.\
  \nPer il versionamento ho utilizzato *GitHub*, condividendo il *repository* con il cliente per assicurare *trasparenza* e *collaborazione*.",
              },
              {
                type: "subtitle",
                value: "Integrazione di Firebase e Pubblicazione",
              },
              {
                type: "text",
                value: "Per la pubblicazione ho scelto *Firebase*, grazie alla sua *semplicità di integrazione* con *GitHub Actions* e alla disponibilità di un *piano gratuito* adeguato alle esigenze iniziali del progetto.\
  \nGrazie alla pipeline di *Continuous Deployment*, ogni modifica al codice viene distribuita automaticamente su Firebase, consentendo anche al cliente di apportare piccoli aggiornamenti senza gestire manualmente il *deploy*.\
  \nSono stati inoltre utilizzati *Firestore* come database, *Firebase Authentication* per la gestione degli accessi e *Firebase Functions* per l'implementazione di *logiche serverless*.",
              },
            ],
          };
        case "One TCG Hero":
          return {
            ...project,
            links: project.links?.map((l) => ({ ...l, label: "One TCG Hero - Sito ufficiale" })),
            description:
              "PWA in React per gestire la mia collezione di carte, con funzioni avanzate di filtro, deck building, stampa e sync su Firestore.",
            longtext: [
              {
                type: "text",
                value: "Ho sviluppato una PWA in React e pubblicata su Firebase per gestire la mia collezione personale di giochi di carte. Ho aggiunto, e in alcuni casi migliorato, diverse funzionalità utili trovate su vari siti, ma mai tutte in un unico posto.\
          \nPer scopi sperimentali e di apprendimento ho iniziato questo progetto utilizzando Lovable, successivamente ho smesso di usarlo ma ho continuato a utilizzare in modo massiccio strumenti di AI per lo sviluppo, scrivendo codice solo quando strettamente necessario per comprendere i reali limiti di questo nuovo tipo di sviluppo.\
          \nSpesso ho creato task su Github con dettagli tecnici e li ho assegnati a Copilot per generare il codice, successivamente ho revisionato e, se necessario, modificato il codice generato per adattarlo alle mie esigenze."
              },
              {
                type: "subtitle",
                value: "Funzionalità implementate",
              },
              {
                type: "text",
                value: "Ecco una lista delle principali funzionalità implementate nell’applicazione:\
          \n- Applicazione con UI responsive per mobile e desktop con supporto sia light che dark mode\
          \n- Autenticazione utente tramite Firebase Auth con email/password\
          \n- Possibilità di applicare filtri complessi per trovare una carta o un set specifico\
          \n- Creazione e gestione della collezione aggiungendo carte singolarmente o importando liste di carte (gestendo anche eventuali merge)\
          \n- Creazione e gestione dei mazzi e, per ciascun mazzo, visualizzazione di statistiche come numero di carte, distribuzione delle rarità, curva dei costi e altro\
          \n- Importazione ed esportazione dei mazzi in diversi formati per varie piattaforme (come simulatori o CardMarket)\
          \n- Stampa delle carte scegliendo layout differenti e numero di carte per pagina\
          \n- Se un utente è abilitato da me, dopo il login collezioni e mazzi vengono salvati su Firestore per avere gli stessi dati su dispositivi diversi",
              },
            ],
          };
        case "GUT":
          return {
            ...project,
            description:
              "PWA stile Spotify per video musicali con pagamenti Stripe, CMS dedicato e contributo al backend Node/Express.",
            links: project.links?.map((l) => ({ ...l, label: "GUT - Sito ufficiale" })),
            longtext: [
              {
                type: "title",
                value: "Caso Studio",
              },
              {
                type: "subtitle",
                value: "Contesto",
              },
              {
                type: "text",
                value: "GUT è una startup operante nel settore musicale, composta da un team snello di tre persone: un CEO, un CTO responsabile dello sviluppo backend e un designer incaricato della progettazione grafica.\
    \nL'obiettivo era realizzare un'applicazione simile a Spotify, arricchita da funzionalità aggiuntive pensate per artisti e utenti.\
    \nMi sono occupato principalmente dello sviluppo frontend insieme a un altro sviluppatore freelance, contribuendo inoltre all'implementazione di alcune funzionalità backend.",
              },
              {
                type: "subtitle",
                value: "Sfide Affrontate",
              },
              {
                type: "text",
                value: "Collaborare con una startup rappresenta una sfida stimolante, poiché i requisiti evolvono rapidamente. Le principali criticità affrontate sono state:\
    \n- Garantire uno streaming audio e video performante\
    \n- Assicurare una navigazione fluida e veloce nonostante l’elevata quantità di dati da caricare (video, immagini e informazioni sugli artisti)\
    \n- Gestire pagamenti e abbonamenti in modo sicuro ed efficiente\
    \n- Progettare un CMS dedicato per amministrare i contenuti della piattaforma in modo semplice e rapido, ottimizzando tempi e risorse",
              },
              {
                type: "subtitle",
                value: "Soluzione Implementata",
              },
              {
                type: "text",
                value: "Per soddisfare i requisiti del progetto è stata sviluppata una piattaforma completa composta da una PWA in React per gli utenti finali, un CMS in React per il team di GUT e un backend in Node.js ed Express.\
              \nDi seguito alcune delle soluzioni adottate per affrontare le principali sfide:\
                \n- Streaming audio e video tramite Mux, un servizio affidabile e performante\
                \n- Ottimizzazione della navigazione attraverso diverse strategia di caricamento asincrono, caching aggressivo e tool per ridurre la dimensione delle immagini caricare dagli artisti\
                \n- Gestione dei pagamenti e degli abbonamenti tramite integrazione con Stripe\
                \n- Sviluppo di un CMS separato in React, progettato in collaborazione con il designer per garantire semplicità d’uso e scalabilità futura",
              },
              {
                type: "title",
                value: "Dettagli Tecnici",
              },
              {
                type: "subtitle",
                value: "Frontend - PWA in React",
              },
              {
                type: "text",
                value: "Ho sviluppato una *Single Page Application* utilizzando *React*, *TypeScript* e *Vite* come build tool. Le principali funzionalità della *PWA* includono:\
  \n- *Design mobile-first* con interfaccia *responsive* realizzata con *CSS* e *Styled Components* tramite *Panda*\
  \n- *Streaming video* tramite *Mux SDK*; gli artisti possono caricare i propri videoclip con visualizzazione della *percentuale di upload*\
  \n- *Sistema di pagamento* integrato con *Stripe* per l’acquisto di *abbonamenti* agli artisti e *token gem* per gli utenti\
  \n- *Ottimizzazione delle performance* tramite *lazy loading* e *strategie di caching avanzate* per ridurre le chiamate al backend\
  \n- *Banner di installazione* per consentire l’installazione della PWA sui dispositivi mobili",
              },
              {
                type: "subtitle",
                value: "Frontend - CMS in React",
              },
              {
                type: "text",
                value: "Ho sviluppato un *sistema di gestione dei contenuti (CMS)* utilizzando *React*, *TypeScript* e *Vite*, mantenendo *coerenza tecnologica* con la PWA per garantire *facilità di manutenzione* ed *evoluzione futura*.\
  \nLa piattaforma è suddivisa in *macrosezioni* dedicate alle principali entità: *User*, *Content*, *Collection* (gruppi di contenuti), *Audition* e *Tags*.\
  \nOgni macrosezione è composta da due tipologie di pagine:\
  \n- Una *pagina tabellare* per visualizzare le entità, con *paginazione*, *ricerca* e *filtri*\
  \n- Una *pagina di dettaglio* per visualizzare, modificare o creare nuove entità\
  \nAnche nel CMS sono state implementate *strategie di caching* per ridurre le chiamate al backend e migliorare le *prestazioni complessive*",
              },
              {
                type: "subtitle",
                value: "Backend - NodeJS and Express",
              },
              {
                type: "text",
                value: "Uno dei fondatori era il principale responsabile dello sviluppo backend, realizzato con *Node.js* ed *Express*, utilizzando *PostgreSQL* come database e *Redis* per il caching.\
  \nHo collaborato attivamente contribuendo a:\
  \n- Progettare alcuni aspetti della *struttura del database*\
  \n- Implementare *strategie di caching* con *Redis*\
  \n- Sviluppare *REST API* utilizzate dalla PWA e dal CMS\
  \n- Effettuare *controlli di sicurezza* per proteggere le API da *vulnerabilità comuni* ed evitare l’esposizione di *dati sensibili*\
  \n- Redigere la *documentazione delle API* tramite *Swagger*\
  \n- Eseguire attività di *debug* e risolvere *bug* emersi durante lo sviluppo della PWA e del CMS",
              },
            ],
          };
        case "Portfolio Online":
          return {
            ...project,
            description:
              "Ho creato questo portfolio online per mostrare competenze ed esperienze usando React, Typescript e strumenti di AI, pubblicato su Firebase.",
            links: project.links?.map((l) => {
              if (l.label === "Website") return { ...l, label: "Sito" };
              if (l.label === "Github") return { ...l, label: "GitHub" };
              return l;
            }),
            longtext: [
              {
                type: "title",
                value: "Caso Studio",
              },
              {
                type: "subtitle",
                value: "Contesto",
              },
              {
                type: "text",
                value: "Questo è un progetto personale che ho realizzato per avere in un unico posto tutte le mie competenze, esperienze e progetti passati."
              },
              {
                type: "subtitle",
                value: "Sfide Affrontate",
              },
              {
                type: "text",
                value: "Le principali sfide affrontate sono state:\
                \n- Progettare un sito con una UI e una UX che mi piacesse e che fosse anche funzionale per mostrare tutte le informazioni che volevo condividere\
                \n- Trovare un modo per aggiornare facilmente e velocemente il sito con nuove informazioni, progetti o esperienze senza dover modificare manualmente il codice ogni volta\
                \n- Avere un sito che sia indicizzato da Google e che appaia nei primi risultati di ricerca quando qualcuno cerca il mio nome\
                \n- Fare in modo che il sito non fosse solo una vetrina ma, con le funzionalità implementate, fosse anche un modo per mostrare concretamente le mie competenze tecniche e di sviluppo\
                \n- Poter scaricare una versione PDF semplificata del portfolio"
              },
              {
                type: "subtitle",
                value: "Soluzione Implementata",
              },
              {
                type: "text",
                value: "Dopo molte ricerche sono partito da un template online che mi piaceva e ho creato e migliorato questo portfolio, aggiungendo nuovi componenti e integrando strumenti di AI. In particolare:\
                \n- Ho cercato di organizzare le informazioni mettendo in evidenza cosa può interessare di più a potenziali clienti\
                \n- Ho raccolto tutte le informazioni in un json che viene letto dal sito per mostrare le informazioni, in questo modo posso aggiornare facilmente il sito modificando solo quel file senza dover toccare il codice\
                \n- Ho applicato tecniche SEO per migliorare l’indicizzazione del sito su Google, come l’utilizzo di meta tag, sitemap e l'inclusione di una sezione blog con articoli e post che pubblico anche sul mio Linkedin\
                \n- Ho incluso anche un chatbot che usa API di AI gratuite per rispondere a domande su di me basandosi sulle informazioni presenti nel sito\
                \n- Ho incluso una funzionalità per scaricare una versione PDF semplificata del portfolio basandosi sempre sulle informazioni del json, in questo modo posso aggiornare anche il PDF semplicemente modificando il json senza dover modificare manualmente un file PDF ogni volta"
              },
              {
                type: "title",
                value: "Dettagli tecnici",
              },
              { type: "subtitle", value: "Tecnologie e librerie" },
              {
                type: "text",
                value:
                  "- *React* come framework\
                    \n- *Typescript* come linguaggio\
                    \n- *style-components* come libreria per la gestione degli stili\
                    \n- *GitHub* come sistema di versionamento\
                    \n- *Firebase* per il deploy e l’hosting\
                    \n- *jspdf* e *html2canvas* per generare una versione PDF semplificata del portfolio\
                    \n- *Firebase Authentication* per la gestione del login per aggiungere articoli al blog\
                    \n- *Firebase Firestore* per salvare gli articoli del blog\
                    \n- *Firebase Functions* per gestire le funzioni serverless come la gestione degli articoli del blog e le richieste al chatbot\
                    \n- Piani free di *Groq* e *Google AI* per il chatbot",
              },
            ],
          };
        case "Startup - Kangury":
          return {
            ...project,
            description:
              "Ho sviluppato un’applicazione fullstack utilizzando React per il frontend e Django per il backend.\
              \nIn Kangury è possibile acquistare foto che verranno associate a un album contenente le proprie foto o video.\
              \nVisita il sito per saperne di più!",
            links: project.links?.map((l) => ({ ...l, label: "Kangury - Sito ufficiale" })),
            longtext: [
              {
                type: "text",
                value:
                  "Ho sviluppato l’applicazione che puoi provare dai link forniti. Al suo interno gli utenti possono acquistare diversi prodotti legati al mondo della fotografia e, ovviamente, modificare e stampare le proprie foto in diversi formati.\
            \nDopo aver acquistato una foto, l’utente può associarla a un album in cui può caricare le proprie foto o video.\
            \nSe sei interessato a collaborare a questa startup contattami e posso fornirti anche un codice sconto!",
              },
              {
                type: "subtitle",
                value: "Introduzione",
              },
              {
                type: "text",
                value:
                  "Ho utilizzato le seguenti tecnologie per 3 motivi principali:\
            \n- Le conoscevo già e potevo sviluppare l’applicazione in poco tempo\
            \n- Conoscevo servizi su cui distribuire rapidamente l’applicazione con costi nulli o molto bassi all’inizio\
            \n- Sono tecnologie solide e ben conosciute, utilizzate in molti grandi progetti e con una community ampia che può aiutare in caso di problemi",
              },
              {
                type: "subtitle",
                value: "PWA in React",
              },
              {
                type: "text",
                value:
                  "Funzionalità principali dell’applicazione web che ho utilizzato/sviluppato:\
          \n- Bootstrap 5 con SASS personalizzato per avere un tema facile da mantenere e aggiornare in futuro; ha anche velocizzato la creazione dell’app considerando che non avevo un UI designer\
          \n- Redux per gestire lo store dell’applicazione\
          \n- Firebase per distribuire l’applicazione su 2 branch differenti, produzione e test, così da avere un ambiente di test dove verificare le modifiche prima del deploy in produzione\
          \n- Editor di foto avanzato che permette all’utente di modificare le immagini ritagliandole e ruotandole\
          \n- Google Analytics per tracciare il comportamento degli utenti all’interno dell’applicazione\
          \n- Swiper per diversi carousel all’interno dell’applicazione"
              },
              {
                type: "subtitle",
                value: "Backend in Django",
              },
              {
                type: "text",
                value:
                  "Per il backend ho utilizzato Django con database mysql e ho organizzato le diverse API in una documentazione Swagger.\
          \nHo utilizzato bucket Amazon AWS S3 per salvare le foto e i video caricati dagli utenti.",
              },
            ],
          };
        case "Personal Project - Digitalpix":
          return {
            ...project,
            description:
              "Ho sviluppato, in React, una PWA e un’applicazione store (per iOS e Android) per personalizzare e acquistare foto professionali.",
            longtext: [
              {
                type: "text",
                value:
                  "Ho sviluppato l’applicazione che puoi provare dai link forniti. Al suo interno gli utenti possono acquistare diversi prodotti legati al mondo della fotografia e, ovviamente, modificare e stampare le proprie foto in diversi formati.",
              },
              {
                type: "subtitle",
                value: "Analisi del Problema",
              },
              {
                type: "text",
                value:
                  "Innanzitutto il mio lavoro è stato trovare le tecnologie migliori per sviluppare ciò di cui Digitalpix aveva bisogno: un’applicazione web più accessibile da dispositivi mobili e un’app mobile da pubblicare su Google Play Store e Apple App Store.\
            \nAvendo un budget ridotto e lavorando da solo ho deciso di sviluppare una PWA (Progressive Web Application) utilizzando React e successivamente un’app mobile in React Native che includesse una WebView per visualizzare la PWA.\
            \nIn questo modo posso utilizzare lo stesso codice sia per l’applicazione web che per quella mobile. Inoltre non è necessario pubblicare l’app mobile su Google Store e Apple Store a ogni aggiornamento, riducendo drasticamente i tempi di deploy e la manutenzione per Digitalpix dopo il rilascio.",
              },
              {
                type: "subtitle",
                value: "Web App in React",
              },
              {
                type: "text",
                value:
                  "Funzionalità principali dell’applicazione web utilizzata/sviluppata:\
          \n- Bootstrap 5 con SASS personalizzato per avere un tema facile da mantenere e aggiornare in futuro; ha anche velocizzato la creazione dell’app considerando che non avevo un UI designer\
          \n- Redux per gestire lo store dell’applicazione\
          \n- Firebase per distribuire l’applicazione su 2 branch differenti, produzione e test, così da avere un ambiente di test dove verificare le modifiche prima del deploy in produzione\
          \n- Editor di foto avanzato che permette all’utente di modificare le immagini ritagliandole e ruotandole\
          \n- Google Analytics per tracciare il comportamento degli utenti all’interno dell’applicazione\
          \n- Swiper per diversi carousel all’interno dell’applicazione"
              },
              {
                type: "subtitle",
                value: "App Mobile in React Native",
              },
              {
                type: "text",
                value:
                  "Per pubblicare l’applicazione anche sugli store mobile ho sviluppato un’app in React Native includendo una WebView che mostra l’applicazione web.\
          \nIn questo modo posso utilizzare lo stesso codice sia per l’applicazione web che per quella mobile. Inoltre non è necessario pubblicare l’app mobile su Google Store e Apple Store a ogni aggiornamento, riducendo drasticamente i tempi di deploy.\
          \nLavorando da solo e solo nel tempo libero ho considerato questa la soluzione migliore per ottenere un buon risultato in poco tempo.",
              },
              {
                type: "subtitle",
                value: "Backend",
              },
              {
                type: "text",
                value: "Durante il progetto ho suggerito diverse soluzioni per migliorare l’architettura software di Digitalpix e risolvere alcuni problemi emersi durante lo sviluppo.\
          \nI principali aggiornamenti suggeriti sono stati:\
          \n- Creare una documentazione Swagger per tutte le API utilizzate, così da avere una documentazione chiara su come usarle e quali dati inviare/ricevere\
          \n- Salvare tutte le soluzioni software utilizzate internamente in un profilo Github creato per Digitalpix, così da avere un sistema di versionamento e un backup di tutto il codice sviluppato"
              },
            ],
          };
        case "Personal Project - Climberworld Web App":
          return {
            ...project,
            description:
              "Web app fullstack (React + Flask) che raccoglie info su rifugi, escursioni e falesie alpine. Backend offline, demo frontend online.",
            links: project.links?.map((l) => ({ ...l, label: "Climberworld" })),
            longtext: [
              {
                type: "text",
                value:
                  "Nel mio tempo libero ho lavorato a questa applicazione per imparare cose nuove, mantenere allenate le conoscenze che già avevo e acquisirne di nuove.\
            \nHo sviluppato sia il frontend che il backend.",
              },
              {
                type: "subtitle",
                value: "Frontend",
              },
              {
                type: "text",
                value:
                  "Per il frontend queste sono le principali tecnologie che ho utilizzato:\
                    \n- *React* come frontend\
                    \n- *Redux* per gestire lo store dell’applicazione\
                    \n- *Styled* components per gestire lo stile\
                    \n- *Firebase* per distribuire l’applicazione",
              },
              {
                type: "subtitle",
                value: "Backend",
              },
              {
                type: "text",
                value:
                  "Per il backend queste sono le principali tecnologie che ho utilizzato:\
                    \n- *Flask* micro-framework sviluppato in Python\
                    \n- *mysql* per gestire il database poiché le informazioni all’interno dell’applicazione sono ben strutturate\
                    \n- *phpmyadmin docker image* utilizzata in locale per esplorare il database tramite un’interfaccia grafica\
                    \n- *docker* e *docker-compose* per sviluppare facilmente il backend in locale eseguendo 3 immagini docker: una per Flask, una per mysql e una per phpmyadmin\
                    \n- *Swagger* per creare una documentazione chiara delle API\
                    \n- *pythonanywhere* per distribuire l’applicazione\
                    \n- *marshmallow, SQLAlchemy e connexion* per gestire facilmente le tabelle del database all’interno delle API",
              },
              {
                type: "subtitle",
                value: "Altre Tecnologie/Strumenti",
              },
              {
                type: "text",
                value: "- *Git*:\
                    \n- *Visual Studio Code*",
              },
            ],
          };
        case "Diva - Custom Video Player":
          return {
            ...project,
            description:
              "Player video personalizzato con molte funzionalità sviluppato per essere integrato in diverse piattaforme (web, TV, mobile ecc.).\
        Il progetto è sviluppato come libreria divisa in diversi pacchetti, uno per le diverse destinazioni in cui Diva viene utilizzato (web, mobile, TV, ecc.).",
            links: project.links?.map((l) => ({ ...l, label: "DeltaTre - Diva" })),
            longtext: [
              {
                type: "text",
                value:
                  "Ho lavorato, utilizzando metodologie Agile, come frontend developer sul progetto Diva con l’obiettivo di migliorare le funzionalità esistenti e svilupparne di nuove.",
              },
              {
                type: "subtitle",
                value: "Descrizione del Progetto",
              },
              {
                type: "text",
                value:
                  "Diva era una libreria player venduta da DeltaTre a diversi clienti che la integravano all’interno dei propri servizi di streaming.\
                    \nAl suo interno era suddivisa in diversi pacchetti dedicati a:\
                    \n- Funzionalità comuni utilizzate trasversalmente in più pacchetti\
                    \n- Componenti specifici, o insiemi di componenti, utilizzabili in modo standalone e venduti singolarmente oppure integrati in pacchetti più grandi",
              },
              {
                type: "subtitle",
                value: "Tecnologie Utilizzate",
              },
              {
                type: "text",
                value:
                  "- *React* come framework frontend (con *Typescript* e *SCSS*) \
                    \n- *Typescript* per gestire le diverse strutture utilizzate nel progetto e intercettare errori in fase di compilazione\
                    \n- *RXjs* per semplificare la gestione del codice asincrono e basato su callback causato dallo streaming video\
                    \n- *SCSS* per gestire gli stili dei componenti e mantenere un’architettura più organizzata rispetto al CSS puro\
                    \n- *Storybook.JS* per gestire la documentazione dei componenti condivisi utilizzati nei diversi pacchetti del progetto\
                    \n- *Git* come sistema di versionamento\
                    \n- *VS Code* come IDE\
                    \n- *Yarn* per eseguire e buildare le diverse parti di Diva\
                    \n- *Jest* per la gestione dei test unitari\
                    \n- *JSON* come formato standard per lo scambio di dati tra frontend e backend\
                    \n- *Jira* per la gestione delle task e delle issue di progetto\
                    \n- *Windows* o *MacOS* come sistemi operativi",
              },
              {
                type: "subtitle",
                value: "Workflow",
              },
              {
                type: "text",
                value:
                  "Abbiamo lavorato in sprint di 2 settimane e, tra uno sprint e l’altro, presentavamo il lavoro completato e decidevamo quali user story affrontare nelle iterazioni successive.\
                      Le story potevano essere create dai team che analizzavano i prossimi componenti da implementare, oppure da me e dal mio team quando volevamo:\
                      \n- Eseguire un refactor importante del codice\
                      \n- Aggiornare componenti esistenti\
                      \n\nQuando completavamo una user story, la distribuivamo nell’ambiente *dev* per test interni. Successivamente la distribuivamo nell’ambiente *test* per permettere al team QA di verificare che tutti i requisiti fossero soddisfatti senza errori. Se i requisiti non venivano rispettati o venivano individuati problemi, correggevamo le anomalie e ridistribuivamo prima in *dev* e poi in *test*. Ripetevamo questo processo fino a quando la user story soddisfaceva completamente i requisiti senza bug o errori.\
                      \nNel nostro workflow utilizzavamo tre ambienti differenti: *dev*, *test* e *prod*.\
                      \n- *dev* veniva utilizzato per i test da parte degli sviluppatori e la validazione iniziale dei requisiti\
                      \n- *test* veniva utilizzato come ambiente stabile di pre-produzione per demo ufficiali quando necessario\
                      \n- *prod* era l’ambiente finale in cui l’applicazione veniva distribuita ed utilizzata dai clienti reali",
              },
            ]

          };
        case "TeamSystems - Digital Box":
          return {
            ...project,
            description:
              "Applicazione web progettata per studi professionali che desideravano implementare processi di condivisione delle informazioni, migliorare il rapporto con i propri clienti e coinvolgerli attraverso lo scambio di informazioni anche in tempo reale.",
            links: project.links?.map((l) => ({ ...l, label: "Digital Box" })),
            longtext: [
              {
                type: "text",
                value:
                  "Ho lavorato, utilizzando metodologie Agile, come frontend developer sull’applicazione Digital Box per aggiornare le funzionalità già disponibili e implementarene di nuove. Inoltre, ho corretto bug e refactorizzato componenti legacy per rendere il codice più leggibile e migliorare le performance.",
              },
              {
                type: "subtitle",
                value: "Tecnologie Utilizzate",
              },
              {
                type: "text",
                value:
                  "- *React* come framework frontend (con *Javascript* e *HTML*, ovviamente) \
                    \n- *Redux* per la gestione dello stato dell’applicazione\
                    \n- *CSS* per gestire gli stili dei componenti creati internamente\
                    \n- *Jest* per la gestione dei test unitari\
                    \n- *Cypress* per la gestione dei test di integrazione\
                    \n- *Storybook.JS* per la documentazione dei componenti comuni utilizzati in diverse parti dell’applicazione\
                    \n- *Git* come sistema di versionamento\
                    \n- *Python* per automatizzare alcune attività durante il processo di sviluppo\
                    \n- *Docker* per eseguire il backend in locale\
                    \n- *VS Code* come IDE\
                    \n- *JSON* come formato standard per lo scambio di dati tra frontend e backend\
                    \n- *Swagger* come documentazione per analizzare le API backend\
                    \n- *Jira* per la gestione delle attività e delle issue di progetto\
                    \n- *Windows* o *MacOS* come sistemi operativi",
              },
              {
                type: "subtitle",
                value: "Workflow",
              },
              {
                type: "text",
                value:
                  "Abbiamo lavorato in sprint di 2 settimane e, tra uno sprint e l’altro, presentavamo il lavoro svolto e decidevamo quali user story affrontare nei successivi sprint.\
                    Le storie potevano essere create dai team che analizzavano i prossimi componenti da implementare oppure dal mio team quando volevamo:\
                    \n- Effettuare un refactor significativo del codice\
                    \n- Aggiornare componenti esistenti\
                    \n\nUna volta completata una user story, la distribuivamo nell’ambiente *dev* per i test interni. Successivamente la distribuivamo nell’ambiente *test* per permettere al team di QA di verificare il rispetto dei requisiti senza errori. In caso di problemi, correggevamo le anomalie e ridistribuivamo prima in *dev* e poi in *test*. Questo processo veniva ripetuto fino al completo soddisfacimento dei requisiti senza bug o errori.\
                    \nNel nostro workflow utilizzavamo tre ambienti distinti: *dev*, *test* e *prod*.\
                    \n- *dev* veniva utilizzato per i test tra sviluppatori e la validazione iniziale dei requisiti\
                    \n- *test* fungeva da ambiente pre-produzione stabile per demo ufficiali quando necessario\
                    \n- *prod* era l’ambiente finale in cui l’applicazione veniva distribuita ed utilizzata dai clienti reali",
              },
              {
                type: "subtitle",
                value: "Interazione con il backend",
              },
              {
                type: "text",
                value:
                  "Non facevamo affidamento su un unico server backend, ma su diversi servizi, alcuni sviluppati con Spring Boot (Java) e altri con NodeJS (JavaScript).\
                    \nQuando distribuivamo nuovi componenti o funzionalità nell’applicazione, le API necessarie potevano essere già disponibili oppure no.\
                    \nNel primo caso le utilizzavamo direttamente e, se necessario, suggerivamo eventuali miglioramenti.\
                    \nNel secondo caso, simulavamo le risposte del server nello store Redux, condividendo con il team backend la struttura JSON dei dati mockati affinché potessero implementare le API.",
              },
            ],

          };
        case "Personal Project - Traveltips Web Application":
          return {
            ...project,
            description:
              "Social di viaggio per condividere info su città e luoghi turistici. Ho sviluppato frontend e backend per una startup non più interessata a completare il progetto; backend ora offline, frontend visibile.",
            links: project.links?.map((l) => {
              if (l.label === "Traveltips App") return { ...l, label: "Traveltips App" };
              if (l.label === "Traveltips App Git") return { ...l, label: "Repo frontend" };
              if (l.label === "Traveltips Backend Git") return { ...l, label: "Repo backend" };
              return l;
            }),
            longtext: [
              {
                type: "text",
                value:
                  "Applicazione web che gli utenti potevano utilizzare per condividere informazioni su città e luoghi turistici, come un social network focalizzato sui viaggi.\nHo sviluppato sia il backend che il frontend per una startup, ma il progetto non è stato completato perché non erano più interessati a portarlo avanti. Al momento il backend non è attivo, è visibile solo il frontend.",
              },
              {
                type: "subtitle",
                value: "Tecnologie Frontend",
              },
              {
                type: "text",
                value: "Per il frontend queste sono le principali tecnologie che ho utilizzato:",
              },
              {
                type: "text",
                value:
                  "*React* come frontend,\n*Redux* per gestire lo store dell’applicazione \n*Bootstrap* 5 per gestire la parte grafica dell’applicazione \n*Firebase* per il deploy dell’applicazione\n*Jest* per la gestione dei test",
              },
              {
                type: "text",
                value:
                  "Ho organizzato l’architettura dell’applicazione in 6 cartelle principali:",
              },
              {
                type: "text",
                value:
                  "- *bootstrap* contiene tutto il codice SCSS che definisce le classi utilizzate nell’applicazione\
                \n- *components* contiene tutti i componenti UI renderizzati all’interno dell’applicazione\
                \n- *languages* contiene un file JSON per ogni lingua selezionabile dall’utente nell’applicazione\
                \n- *pages*\
                \n- *store* gestisce le informazioni salvate nell’applicazione, incluse tutte le azioni che gli altri componenti possono usare per interagire con lo store e con i servizi API\
                \n- *utils* contiene una lista di funzionalità utilizzate in diverse parti dell’applicazione, suddivise in più file",
              },
              {
                type: "subtitle",
                value: "Backend",
              },
              {
                type: "text",
                value: "Per il backend queste sono le principali tecnologie che ho utilizzato:",
              },
              {
                type: "text",
                value:
                  "- *Flask* micro-framework sviluppato in *Python*, ho scelto questo linguaggio per diversi motivi: lo sviluppo in Python è più rapido e in futuro sarebbe stato più semplice integrare il backend con algoritmi di raccomandazione scritti in Python per migliorare l’esperienza utente\
                \n- *mysql* per la gestione del database, poiché le informazioni dell’applicazione erano ben strutturate\
                \n- *phpmyadmin* come immagine Docker utilizzata in locale per esplorare il database tramite interfaccia grafica\
                \n- *docker* e *docker-compose* per sviluppare facilmente il backend in locale, eseguendo tre immagini Docker: una per Flask, una per mysql e una per phpmyadmin\
                \n- *Swagger* per creare una documentazione chiara delle API\
                \n- *marshmallow*, *SQLAlchemy* e *connexion* per gestire facilmente le tabelle del database all’interno delle API",
              },
              {
                type: "subtitle",
                value: "Altre tecnologie",
              },
              {
                type: "text",
                value:
                  "- *Git*\
                \n- *Visual Studio Code*",
              },
            ],

            allSkills: project.allSkills,
          };
        case "Stellantis - Validation of ADAS System":
          return {
            ...project,
            description:
              "Consulente in Stellantis in un team ingegneria che gestisce tool per validare algoritmi di guida autonoma con team distribuiti.",
            longtext: [
              {
                type: "text",
                value:
                  "Come consulente, ho lavorato presso Stellantis (precedentemente FCA) su un grande progetto relativo alla guida autonoma.",
              },
              {
                type: "subtitle",
                value: "Cosa ho fatto",
              },
              {
                type: "text",
                value:
                  "Ho lavorato, utilizzando la metodologia AGILE, all’interno di un team di ingegneria che gestiva diversi strumenti utilizzati da altri team per validare gli algoritmi di guida autonoma. Collaboravamo con più team dislocati in diverse parti del mondo.\
                    \nAlcune delle nostre principali attività erano:\
                    \n- Personalizzare il software di simulazione acquistato da Stellantis in base a requisiti specifici (utilizzando C++ per il core e C#/Unity per la GUI)\
                    \n- Implementare immagini Docker con test specifici e distribuirle su un cluster, permettendo ad altri team di eseguire test da remoto\
                    \n- Implementare DAG in Airflow (utilizzando Python) per gestire attività di pipeline come il salvataggio dei KPI in un database\
                    \n- Creare dashboard Grafana per visualizzare i risultati delle simulazioni\
                    \n- Definire insieme ad altri team le nuove funzionalità e i test da implementare nello strumento di simulazione",
              },
              {
                type: "subtitle",
                value: "Metodologia",
              },
              {
                type: "text",
                value:
                  "Lavoravamo seguendo la metodologia AGILE SCRUM con sprint della durata di 2 settimane.\
                    \nNon ci occupavamo solo degli item aggiunti dal nostro APO, ma proponevamo anche attività utili al raggiungimento degli obiettivi di delivery.",
              },
              {
                type: "subtitle",
                value: "Linguaggi di programmazione",
              },
              {
                type: "text",
                value:
                  "- *C++*\
                    \n- *Python*\
                    \n- *C#*\
                    \n- *Bash script*",
              },
              {
                type: "subtitle",
                value: "Sistemi Operativi",
              },
              {
                type: "text",
                value:
                  "- *Ubuntu* (principalmente)\
                    \n- *Windows 10*",
              },
              {
                type: "subtitle",
                value: "Altre Tecnologie",
              },
              {
                type: "text",
                value:
                  "- *Visual Studio Code*\
                    \n- *Unity*\
                    \n- *Github*\
                    \n- *Docker*\
                    \n- *Airflow*\
                    \n- *Jenkins*\
                    \n- *Codebeamer*\
                    \n- *Grafana*\
                    \n- *Formati di mappa NDS e OpenDRIVE*\
                    \n- *Google Sheets online* (documenti, fogli di calcolo, presentazioni)\
                    \n- *ROS*",
              },
            ]

          };
        case "Accenture - React-Redux Application for a Big Company in the Energy Sector":
          return {
            ...project,
            description:
              "Applicazione web React/Redux per raccogliere e visualizzare dati in tempo reale da stazioni distribuite in Italia (settore energia).",
            longtext: [
              {
                type: "text",
                value:
                  "Nel mio quarto progetto ho sviluppato una web application utilizzando React con Redux.\
                  \nHo lavorato in modalità agile (Scrum nello specifico) in un team composto principalmente da 2 sviluppatori frontend, 2 analisti funzionali, 1 UI designer, 2 sviluppatori backend e 1 Scrum Master.\
                  \nHo realizzato un'applicazione React per raccogliere e visualizzare diversi dati, provenienti in modo asincrono da varie stazioni distribuite in tutta Italia.",
              },
              {
                type: "subtitle",
                value: "Linguaggi Utilizzati",
              },
              {
                type: "text",
                value:
                  "- *HTML*\
                  \n- *CSS*\
                  \n- *Sass*\
                  \n- *JS6*\
                  \n- *Python*\
                  \n- *Java*",
              },
              {
                type: "subtitle",
                value: "Tecnologie Utilizzate",
              },
              {
                type: "text",
                value:
                  "- *React*\
                  \n- *Redux Saga*\
                  \n- *NodeJS*\
                  \n- *Stencil JS*\
                  \n- *Storybook UI*\
                  \n- *Chrome, Firefox, Safari e IE11* per testare e modificare i componenti a runtime\
                  \n- *Visual Studio Code* come editor\
                  \n- *Git* per il repository online\
                  \n- *Jupyter Notebook* per il codice Python\
                  \n- *MQTT* per collegarsi al server",
              },
              {
                type: "subtitle",
                value: "Librerie Utilizzate",
              },
              {
                type: "text",
                value:
                  "Abbiamo introdotto solo poche librerie per implementare componenti complessi.\
                  \n- *LeafletJS* per realizzare una mappa interattiva, uno dei componenti principali della homepage\
                  \n- *D3.js* per disegnare SVG dinamici e personalizzati\
                  \n- *React Intl* per supportare il multi-lingua nel sito",
              },
              {
                type: "subtitle",
                value: "Cosa Ho Fatto",
              },
              {
                type: "text",
                value:
                  "Di seguito descrivo i principali componenti che ho sviluppato durante il progetto, senza entrare nei dettagli relativi al cliente.",
              },
              {
                type: "subtitle",
                value: "1) Mappa Interattiva",
              },
              {
                type: "text",
                value:
                  "Uno dei primi componenti è stata una mappa centrata sull’Italia. Per realizzarla ho utilizzato Leaflet JS.\
                  \nHo posizionato sulla mappa un'icona, usando le coordinate geografiche, per ogni stazione dell’azienda. Quando l’utente cliccava su un’icona, appariva un popup che mostrava i dati relativi alla stazione, aggiornati in tempo reale.\
                  \nDal popup l’utente poteva anche accedere alla pagina della stazione cliccando sul titolo.\
                  \nSuccessivamente ho aggiunto un'immagine sopra l’Italia e un'altra su Europa e Nord Africa per applicare un filtro di opacità su tutti i paesi tranne l’Italia.\
                  \nHo limitato lo zoom e lo spostamento della mappa per concentrare l’attenzione dell’utente sull’Italia. Alcuni oggetti scomparivano quando l’utente effettuava uno zoom troppo ravvicinato, mostrando solo le stazioni.",
              },
              {
                type: "subtitle",
                value: "2) Server con NodeJS",
              },
              {
                type: "text",
                value:
                  "All’inizio dello sviluppo frontend non avevamo un backend, quindi ho creato un server NodeJS locale per inviare dati fittizi al frontend tramite GET (per ottenere informazioni di base sulle stazioni) e tramite socket per inviare dati asincroni ogni secondo.",
              },
              {
                type: "subtitle",
                value: "3) Grafica SVG",
              },
              {
                type: "text",
                value:
                  "Per ogni stazione erano presenti diverse pagine che mostravano dati provenienti dal server. Alcune pagine includevano grafici che rappresentavano componenti della stazione con i dati. Ho utilizzato D3.js per creare grafici SVG adattabili alle dimensioni della pagina senza perdere qualità.\
                  \nMolte pagine avevano componenti grafici simili. Per evitare codice ripetuto, per ogni tipo di componente ho creato una funzione che disegnava e personalizzava il componente usando una configurazione JSON passata dalla pagina corrente.",
              },
              {
                type: "subtitle",
                value: "4) Supporto Multilingua",
              },
              {
                type: "text",
                value:
                  "Ho utilizzato React Intl per supportare inglese e italiano. Con questa libreria ho creato due file JSON, uno per i termini italiani e uno per quelli inglesi, assegnando lo stesso set di chiavi alla traduzione corretta.\
                  \nHo poi creato una funzione globale utilizzabile in tutto il codice: si passa una chiave e la funzione restituisce la traduzione corretta in base alla lingua salvata nel local storage.\
                  \nQuando l’utente cambiava lingua, salvavo la nuova impostazione nel session storage e la pagina veniva ricaricata per aggiornare la lingua.",
              },
              {
                type: "subtitle",
                value: "5) Redux-Saga",
              },
              {
                type: "text",
                value:
                  "Per salvare i dati provenienti dal server abbiamo utilizzato Redux-Saga.\
                  \nRicevevamo dati asincroni e grazie a Redux evitavamo valori duplicati per la stessa proprietà. Inoltre, lo stato centralizzato dell’applicazione ci permetteva di gestirlo più facilmente e, con uno strumento installato su Chrome, era possibile monitorarne l’evoluzione semplificando il debug.\
                  \nCon Redux abbiamo separato i dati dall’applicazione, così il frontend non doveva gestire la connessione al server, ma solo utilizzare i dati ricevuti.\
                  \nAbbiamo implementato tutta la logica di comunicazione e recupero dati in Redux, rendendo il codice più pulito e manutenibile.",
              },
              {
                type: "subtitle",
                value: "6) Creazione JSON per i dati",
              },
              {
                type: "text",
                value:
                  "Dopo aver deciso il formato migliore per memorizzare i dati nell’applicazione, ho creato JSON con dati casuali utilizzando Python.\
                  \nHo utilizzato Python per due motivi:\
                  \n- I dati non erano completamente casuali, ma rientravano in determinati intervalli\
                  \n- Manipolavo e modificavo questi JSON molte volte, risparmiando tempo grazie a Python\
                  \nQuando abbiamo ottenuto i dati reali dai file CSV, ho utilizzato Python per elaborarli e creare JSON realistici da fornire al backend, così sapevano in quale formato inviare i dati reali.",
              },
              {
                type: "subtitle",
                value: "7) Componenti in puro CSS",
              },
              {
                type: "text",
                value:
                  "Per migliorare le performance, abbiamo evitato l’uso di script quando possibile. Ad esempio, abbiamo utilizzato accordion e toggle realizzati interamente in CSS per i filtri.",
              },
              {
                type: "subtitle",
                value: "8) Connessione MQTT",
              },
              {
                type: "text",
                value:
                  "Quando il backend è stato pronto, abbiamo provato una prima connessione con socket, ma le tecnologie del backend supportavano solo la comunicazione MQTT. Abbiamo quindi realizzato una connessione MQTT sottoscrivendo il client a un topic in cui il server inseriva i dati in coda.",
              },
              {
                type: "subtitle",
                value: "9) Grafici Funzionali SVG",
              },
              {
                type: "text",
                value:
                  "Per disegnare il grafico cartesiano di alcune funzioni complesse date le equazioni, ho utilizzato Python per calcolare un insieme di punti, poi utilizzati in React per tracciare la funzione.\
                  \nNei grafici cartesiani ho implementato due funzionalità:\
                  \n- La possibilità di trascinare e zoomare il grafico\
                  \n- La possibilità di selezionare una specifica sezione del grafico e ingrandirla",
              },
            ]

          };
        case "Accenture - Gazzetta dello Sport":
          return {
            ...project,
            description:
              "Progetto ad alte prestazioni per il sito della Gazzetta: ottimizzazione CSS/JS, componenti riusabili e test Galen.",
            links: project.links?.map((l) => ({ ...l, label: "Gazzetta dello Sport" })),
            longtext: [
              {
                type: "subtitle",
                value: "Linguaggi Utilizzati",
              },
              {
                type: "text",
                value:
                  "- *HTML*\
      \n- *CSS*\
      \n- *Sass*\
      \n- *JavaScript ES6*",
              },
              {
                type: "subtitle",
                value: "Tecnologie Utilizzate",
              },
              {
                type: "text",
                value:
                  "- *Gulp* per l’automazione dei task\
      \n- *Docker* per creare container per eseguire il progetto\
      \n- *Chrome* per testare e modificare i componenti in tempo reale\
      \n- *Visual Studio Code* come editor\
      \n- *Galen* per testare layout e design responsive\
      \n- *Jenkins* per gestire i deploy\
      \n- *Jira* per tracciare task e problemi\
      \n- *GitHub* per il repository online",
              },
              {
                type: "subtitle",
                value: "Architetture Utilizzate",
              },
              {
                type: "text",
                value:
                  "- Utilizzo parziale del framework *Bulma*\
      \n- *SMACSS* e *BEM* per strutturare e nominare le classi CSS in modo coerente",
              },
              {
                type: "subtitle",
                value: "Implementazione",
              },
              {
                type: "text",
                value:
                  "Questo è stato un progetto lungo e complesso, quindi l’ho suddiviso in sezioni più piccole basate sui task che ho gestito.\
      \nI task non sono stati eseguiti in sequenza; spesso ho lavorato su più task in parallelo. Per esempio, ho completato alcune pagine desktop, poi alcune pagine mobile, e poi altre pagine desktop.",
              },
              {
                type: "subtitle",
                value: "1) Pagine Desktop",
              },
              {
                type: "text",
                value:
                  "Inizialmente ho collaborato con un altro sviluppatore per costruire le principali pagine desktop usando HTML e Sass.\
      \nDurante lo sviluppo, abbiamo seguito linee guida chiave:\
      \n- Scrivere codice minimo per mantenere il sito leggero\
      \n- Dividere il sito in componenti riutilizzabili con CSS comune per scalabilità e manutenibilità\
      \n- Usare nomi generici per i componenti, evitando riferimenti specifici alla posizione, come 'top-media'\
      \n- Organizzare il codice seguendo i principi SMACSS e BEM\
      \n- Garantire compatibilità cross-browser e design responsive su Chrome, Firefox, Safari, IE11 e altri",
              },
              {
                type: "subtitle",
                value: "2) Pagine Mobile",
              },
              {
                type: "text",
                value:
                  "Dopo aver completato le pagine desktop, ho sviluppato le pagine mobile usando la stessa architettura. Il CSS è stato separato per migliorare le prestazioni, evitando che gli utenti desktop scaricassero stili non necessari per il mobile.",
              },
              {
                type: "subtitle",
                value: "3) Test con Galen",
              },
              {
                type: "text",
                value:
                  "Una volta completate le prime pagine, il cliente ha introdotto Galen per testare i layout.\
      \nHo avuto la responsabilità di apprendere e applicare Galen. Sebbene fosse semplice per test base, implementare test avanzati era complesso a causa della documentazione limitata e della scarsità di esempi online.\
      \nHo sfruttato le mie capacità di problem solving per creare soluzioni originali per test avanzati usando codice semplice. L’obiettivo era creare un approccio standardizzato, utilizzabile da chiunque, per test veloci delle pagine di progetto attuali e futuri.\
      \nHo utilizzato la sintassi di Galen e JavaScript per script chiave. Una guida dettagliata con problemi e soluzioni sarà condivisa una volta rimossi i dati sensibili.",
              },
              {
                type: "subtitle",
                value: "4) Integrazione con JavaScript",
              },
              {
                type: "text",
                value:
                  "Dopo aver completato la struttura HTML e CSS, altri sviluppatori hanno implementato i componenti JavaScript per rendere il sito completamente funzionante.\
      \nHo collaborato con loro per identificare le soluzioni JavaScript ottimali, aggiungendo attributi come data-target, nuove classi o transizioni in HTML o CSS quando necessario.\
      \nHo anche sviluppato componenti JavaScript complessi, incluso uno scrollbar personalizzato.",
              },
              {
                type: "subtitle",
                value: "5) Ottimizzazioni",
              },
              {
                type: "text",
                value:
                  "Oltre alle best practice per CSS e HTML, abbiamo adottato strategie aggiuntive per migliorare la velocità del sito:\
      \n- Usare un orchestratore per controllare l’ordine di caricamento degli script JavaScript\
      \n- Inserire inline il CSS per i contenuti visibili all’apertura della pagina per ridurre il tempo di caricamento iniziale",
              },
              {
                type: "subtitle",
                value: "6) Compatibilità e Correzione Bug",
              },
              {
                type: "text",
                value:
                  "Per garantire la compatibilità cross-browser e risolvere vari bug, ho ispezionato il codice su tutti i principali browser (Chrome, Firefox, Safari, Edge, IE11) e testato su diversi dispositivi utilizzando macchine virtuali per Windows e emulatori per Android e Safari.",
              },
              {
                type: "subtitle",
                value: "Conclusione",
              },
              {
                type: "text",
                value:
                  "Questo progetto è stata un’esperienza molto preziosa dalla quale ho imparato molto.\
      \nHo acquisito una comprensione approfondita su come scrivere e organizzare HTML, CSS e JavaScript per siti web performanti e manutenibili.",
              },
            ]
          };
        case "Accenture - Static Website for Financial Client":
          return {
            ...project,
            description:
              "Ho lavorato su un progetto già avviato, sviluppando diversi componenti per il sito web di un importante cliente nel settore finanziario. Il sito era strutturato secondo un approccio a “molecole”, e ogni componente è stato progettato per essere completamente responsive, funzionando perfettamente sia su desktop sia su dispositivi mobili.",
            longtext: [
              {
                type: "text",
                value:
                  "Nel mio terzo progetto presso Accenture, ho preso parte a un progetto già avviato e ho contribuito al sito web di un importante cliente nel settore finanziario.\
      \nIl sito era strutturato secondo un approccio a “molecole” e ogni molecola è stata implementata per essere completamente responsive, funzionando senza problemi sia su desktop che su dispositivi mobili.\
      \nQuesto progetto coinvolgeva un team molto ampio, e una delle principali sfide è stata coordinarsi con così tante persone. Spesso, quando affrontavo bug, non erano problemi che potevo risolvere direttamente, quindi dovevo identificare il team appropriato (backend, manutenzione o integrazione), spiegare il problema e seguire l'intero processo fino alla risoluzione completa del bug."
              },
              {
                type: "subtitle",
                value: "Linguaggi Utilizzati"
              },
              {
                type: "text",
                value:
                  "- *HTML*\
      \n- *CSS*\
      \n- *Sass*\
      \n- *JavaScript ES6*"
              },
              {
                type: "subtitle",
                value: "Tecnologie Utilizzate"
              },
              {
                type: "text",
                value:
                  "- *Gulp*\
      \n- *Chrome, Firefox, Safari e IE11* per testare e modificare i componenti in runtime\
      \n- *Visual Studio Code* come IDE\
      \n- *Git* per la gestione dei repository online\
      \n- *Webpack* per il bundling degli script"
              },
              {
                type: "subtitle",
                value: "Librerie Utilizzate"
              },
              {
                type: "text",
                value:
                  "Il progetto non richiedeva prestazioni elevate, quindi abbiamo utilizzato alcune librerie per velocizzare lo sviluppo:\
      \n- *Swiper* per implementare i carousel\
      \n- *Plyr* per un lettore multimediale semplice, accessibile e personalizzabile per YouTube e Vimeo"
              },
              {
                type: "subtitle",
                value: "Contributi Principali"
              },
              {
                type: "text",
                value:
                  "Di seguito sono descritte le principali funzionalità e componenti che ho sviluppato durante il progetto."
              },
              {
                type: "subtitle",
                value: "1) Carousel e Video"
              },
              {
                type: "text",
                value:
                  "Ho sviluppato l'HTML, il CSS e il JavaScript per un carousel utilizzando Swiper. Ho aggiunto un listener per far partire automaticamente il loop delle immagini quando l'utente non interagiva e interromperlo al passaggio del mouse.\
      \nCon Plyr, ho creato un componente personalizzato per inserire video da YouTube o Vimeo, con autoplay opzionale e modalità silenziosa.\
      \nHo integrato Plyr all'interno del carousel, in modo che i video presenti nelle slide partissero automaticamente con audio disattivato quando attivi e si interrompessero al cambio slide.\
      \nSuccessivamente, ho aggiornato il carousel principale per essere utilizzato anche all'interno della pagina, inserito in altre molecole, senza occupare l'intero schermo."
              },
              {
                type: "subtitle",
                value: "2) Ottimizzazione del JavaScript"
              },
              {
                type: "text",
                value:
                  "Sono entrato nel progetto vicino alla consegna finale, quando la maggior parte del lavoro era già completata. Il codice JavaScript era scritto da più sviluppatori senza utilizzare classi o blocchi try-catch, causando errori che interrompevano l'esecuzione poiché Gulp combinava tutti gli script in un unico file.\
      \nPer risolvere questo problema, ho collaborato con un altro sviluppatore per:\
      \n- Organizzare gli script in classi separate e istanziarle in blocchi try-catch distinti, così che un componente difettoso non fermasse gli altri.\
      \n- Sostituire Gulp con Webpack, rendendo gli script più modulari, indipendenti e il codice più robusto."
              },
              {
                type: "subtitle",
                value: "3) Autocomplete"
              },
              {
                type: "text",
                value:
                  "Ho sviluppato una barra di ricerca nell'header, attivabile tramite un pulsante, con funzionalità di completamento automatico. Un listener inviava una richiesta al server ogni volta che l'utente inseriva o cancellava caratteri. Le risposte generate costruivano una lista di suggerimenti.\
      \nLe interazioni dell'utente includevano:\
      \n- Premere Invio per avviare la ricerca e reindirizzare alla pagina dei risultati.\
      \n- Premere il pulsante di chiusura per pulire e nascondere la barra di ricerca.\
      \n- Selezionare un suggerimento con il mouse o navigando nella lista con le frecce e confermare con Invio."
              },
              {
                type: "subtitle",
                value: "4) Pagina di Ricerca"
              },
              {
                type: "text",
                value:
                  "Una volta confermata la query dall'utente, questa veniva salvata nel local storage e l'utente veniva reindirizzato alla pagina dei risultati.\
      \nIn questa pagina, ho implementato una fetch al server tramite API REST (POST con payload JSON) per mostrare i risultati.\
      \nLa grafica della lista dei risultati era complessa, composta da tre sottoliste diverse con strutture grafiche distinte. Ogni campo mostrava parametri diversi in base al JSON ricevuto dal cliente.\
      \nCome per tutto il sito, la pagina era completamente responsive e ottimizzata sia per desktop che per dispositivi mobili.\
      \nHo fatto ampio uso di Flexbox per adattare il layout a tutte le dimensioni di schermo e ho utilizzato mixin solo dove strettamente necessario per minimizzare il codice CSS."
              }
            ]
            ,
          };
        default:
          return project;
      }
    }),
  },
  privacy: {
    title: "🔒 Privacy Policy",
    updatedLabel: "Ultimo aggiornamento",
    sections: [
      {
        heading: "1. Titolare del trattamento",
        paragraphs: [
          "Il titolare del trattamento dei dati è:",
          "Angelo Falci\nSito web: https://angelofalci.com\nEmail di contatto: a.falci@live.it",
        ],
      },
      {
        heading: "2. Tipologia di dati trattati",
        paragraphs: [
          "Questo sito non raccoglie direttamente dati personali tramite moduli di contatto, registrazioni o commenti.",
          "Tuttavia, utilizza Google Analytics, un servizio di analisi statistica fornito da Google LLC, che raccoglie dati di utilizzo in forma aggregata, tra cui:",
        ],
        list: [
          "indirizzo IP (parzialmente anonimizzato)",
          "dati di navigazione (pagine visitate, durata della sessione)",
          "informazioni su browser, dispositivo e sistema operativo",
          "area geografica approssimativa",
        ],
      },
      {
        heading: "3. Finalità del trattamento",
        paragraphs: [
          "I dati raccolti tramite Google Analytics vengono utilizzati esclusivamente per:",
        ],
        list: [
          "analizzare il traffico sul sito",
          "migliorare contenuti, performance ed esperienza utente",
        ],
      },
      {
        heading: "4. Base giuridica del trattamento",
        paragraphs: [
          "Il trattamento dei dati avviene solo previo consenso dell'utente, espresso tramite il banner cookie.",
        ],
      },
      {
        heading: "5. Modalità del trattamento",
        paragraphs: [
          "Il trattamento avviene con strumenti informatici e telematici, nel rispetto delle misure di sicurezza previste dalla normativa vigente.",
        ],
      },
      {
        heading: "6. Servizi di terze parti",
        paragraphs: [
          "Il sito utilizza:",
          "Google Analytics – Google LLC",
          "I dati possono essere trasferiti verso Paesi extra UE (in particolare Stati Uniti), nel rispetto delle garanzie previste dal GDPR.",
          "Maggiori informazioni: https://policies.google.com/privacy",
        ],
      },
      {
        heading: "7. Conservazione dei dati",
        paragraphs: [
          "I dati raccolti tramite Google Analytics vengono conservati per il periodo previsto dalle impostazioni del servizio e comunque non oltre quanto necessario al raggiungimento delle finalità indicate.",
        ],
      },
      {
        heading: "8. Diritti dell'utente",
        paragraphs: [
          "L'utente ha il diritto di:",
        ],
        list: [
          "accedere ai propri dati",
          "chiederne la rettifica o cancellazione",
          "opporsi al trattamento",
          "revocare il consenso in qualsiasi momento",
          "proporre reclamo all'Autorità Garante per la protezione dei dati personali",
        ],
      },
      {
        heading: "9. Modifiche a questa Privacy Policy",
        paragraphs: [
          "Il titolare si riserva il diritto di modificare la presente informativa in qualunque momento. Le modifiche saranno pubblicate su questa pagina.",
        ],
      },
    ],
  },
  cookie: {
    title: "🍪 Cookie Policy",
    updatedLabel: "Ultimo aggiornamento",
    sections: [
      {
        heading: "1. Cosa sono i cookie",
        paragraphs: [
          "I cookie sono piccoli file di testo che i siti visitati inviano al dispositivo dell'utente, dove vengono memorizzati per essere poi ritrasmessi agli stessi siti alla visita successiva.",
        ],
      },
      {
        heading: "2. Tipologie di cookie utilizzati",
        paragraphs: [
          "Cookie tecnici",
          "Questo sito utilizza cookie tecnici necessari al corretto funzionamento del sito. Questi cookie non richiedono il consenso dell'utente.",
        ],
      },
      {
        heading: "Cookie di analisi (Google Analytics)",
        paragraphs: [
          "Il sito utilizza Google Analytics per raccogliere informazioni statistiche in forma aggregata sull'uso del sito.",
          "I cookie di Google Analytics consentono di:",
        ],
        list: [
          "capire come gli utenti utilizzano il sito",
          "migliorare contenuti e prestazioni",
        ],
      },
      {
        heading: "3. Gestione del consenso",
        paragraphs: [
          "Al primo accesso al sito, l'utente può:",
        ],
        list: [
          "accettare i cookie di analisi",
          "rifiutarli",
          "modificare le proprie preferenze in qualsiasi momento",
        ],
      },
      {
        heading: "4. Come disabilitare i cookie dal browser",
        paragraphs: [
          "L'utente può inoltre gestire o disabilitare i cookie direttamente dalle impostazioni del proprio browser. La disabilitazione dei cookie di analisi non compromette il corretto funzionamento del sito.",
        ],
      },
      {
        heading: "5. Cookie di terze parti",
        paragraphs: [
          "I cookie di Google Analytics sono gestiti da Google LLC.",
          "Per maggiori informazioni: https://policies.google.com/privacy",
        ],
      },
      {
        heading: "6. Modifiche alla Cookie Policy",
        paragraphs: [
          "La presente Cookie Policy può essere soggetta a modifiche nel tempo. Le modifiche saranno pubblicate su questa pagina.",
        ],
      },
    ],
  },
};
